/**
 * ROBINHOOD ROUNDING RULES
 *
 * ** Small numbers (numbers less than 1,000)
 * For numbers less than 1, show up to 8 decimals
 * Round to the highest number
 * For numbers less than 10, round to the nearest thousandths place
 * For numbers less than 100, round to the nearest hundredths place
 * For numbers greater than or equal to 100, round to the nearest tenths place
 * ** Large numbers (numbers greater than 1,000)
 * When precision is unnecessary, use abbreviations. Rounded one decimal place out.
 * When precision is necessary, use commas to separate digits. Rounded to the nearest tenths place
 */
var getDecimalCount = function (num) {
    if (num < 0.01) {
        return 8;
    }
    return 2;
};
/**
 * @param num number to convert
 * @param digits number of decimal places
 * @returns string with symbol
 */
export var nFormatter = function (num, precise) {
    if (precise === void 0) { precise = false; }
    var numToUse = Math.abs(num);
    var digits = getDecimalCount(numToUse);
    var roundedNum = Number(numToUse.toFixed(digits));
    var lookup = [
        { value: 0, symbol: "" },
        { value: 1, symbol: "" },
        { value: 1e3, symbol: "K" },
        { value: 1e6, symbol: "M" },
        { value: 1e9, symbol: "B" },
        { value: 1e12, symbol: "t" },
    ];
    var rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    var item = precise
        ? // if precise dont use the lookup, as we dont want to strip the numbers
            { value: 1, symbol: "" }
        : lookup
            .slice()
            .reverse()
            .find(function (item) { return roundedNum >= item.value; });
    var divisor = item && item.value !== 0 ? item.value : 1;
    var formattedNumber = (roundedNum / divisor)
        .toFixed(digits)
        .replace(rx, "$1");
    return item
        ? "".concat(num < 0 ? "-" : "").concat(Number(formattedNumber).toLocaleString("en-US", {
            maximumFractionDigits: 20,
        })).concat(item.symbol)
        : "0";
};
